export default __webpack_public_path__ + "static/media/aboutSectionPic.7e917d4c.png";